import { preventBodyScroll } from '../core/helper-functions'

module.exports = {
  props: ['images'],

  data () {
    return {
      showModal: false,
      previewImages: 3,
      currentIndex: 0,
      slides: 5,
      active: 0,
      currentIndex: 0,
      space: 100
    }
  },

  computed: {
    left(){
      return {
        "left" : (-this.space*this.currentIndex)+"%"
      };
    }
  },

  mounted () {
    var slideCount = this.images.length

    var sliderManager = new Hammer.Manager(document.querySelector('#swipe-box'))

    sliderManager.add(new Hammer.Pan({ threshold: 0, pointers: 0 }))

    sliderManager.on('pan', e => {
      var percentage = 100 / slideCount * e.deltaX / window.innerWidth

      if (e.isFinal) { 
        if (percentage < 0) {
          if (this.currentIndex >= slideCount -1) return
          this.move(1);
        } else if (percentage > 0) {
          if (this.currentIndex === 0) return 
            this.move(-1);
        } else {
          this.move(0);
        }
      }
    });
  },

  methods: {
    move(num){
      this.currentIndex = (this.currentIndex + num + this.images.length) % this.images.length
      this.lazyLoading(this.currentIndex)
    },

    lazyLoading (index) {
      if (index === 0 && this.previewImages < 8) this.previewImages = 4
      if (index === 2 && this.previewImages < 8) this.previewImages = 8
      if (index === 6 && this.previewImages < 14) this.previewImages = 14
      if (index === 10 && this.previewImages < 20) this.previewImages = 20
      if (index === 16 && this.previewImages < 26) this.previewImages = 26
      if (index === 22 && this.previewImages < 32) this.previewImages = 32
      if (index === 28 && this.previewImages < 38) this.previewImages = 38
      if (index === 34 && this.previewImages < 45) this.previewImages = 45
    },

    url (image, index) {
      return this.previewImages >= index ? image : ''
    },

    openModal () {
      this.showModal = true
      preventBodyScroll(true)
    },

    close () {
      this.showModal = false
      preventBodyScroll(false)
    }
  },
 
  template: `
    <div>
      <transition name="fade">
        <book-preview-modal 
          v-if="showModal" 
          :images="images" 
          :currentIndex="currentIndex"
          :left="left"
          :previewImages="previewImages"
          @move="move"
          @close="close"
        />
      </transition>

      <div class="flex justify-content-center align-items-center relative">

        <div class="book-preview__slider overflow-hidden p-3" id="swipe-box">
          <div class="book-preview__slider-wrapper" :style="left">
            <div class="book-preview__slider-item" v-for="(image, index) in images">
              <img :src="url(image, index)" />
            </div>
          </div>
        </div>

        <div class="book-preview__zoom-icon" @click="openModal">
          <i class="fas fa-search-plus" aria-hidden="true"></i>
        </div>
      </div>
    </div>
  `
}

